module.exports = __webpack_public_path__ + "static/media/CDC-EN-notices-P1.4f1c4ff4.jpg";